var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-min-100",attrs:{"id":"app"}},[_c('div',{staticClass:"container-fluid bg-content"},[_c('Header',{attrs:{"isHome":_vm.isHome}}),_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }